import { $height, $scrollTop, $setScrollTop } from 'fxdom/es';
import { $, $Element } from 'rune-ts';

let html_element$: $Element;
let body_element$: $Element;
let device: string | null;
let fixed_top = 0;

if (typeof window !== 'undefined') {
  html_element$ = $(document.querySelector('html'));
  body_element$ = $(document.querySelector('body'));
  device = html_element$?.getAttribute('device');
}

export const bodyFix = () => {
  if (device !== 'mo' && $height(document.body) > window.innerHeight) {
    html_element$.element().style.overflowY = 'scroll';
  }

  fixed_top = $scrollTop(window);

  body_element$.addClass('body-fixed');
  html_element$.element().style.top = (-fixed_top).toString();
};

export const bodyUnfix = () => {
  html_element$.element().style.overflowY = '';

  body_element$.removeClass('body-fixed');
  html_element$.element().style.top = '';
  $setScrollTop(fixed_top, window);
  fixed_top = 0;
};
